module.exports = __webpack_public_path__ + "img/dibeijing.1504f07e.jpg";